<template>
    <div class="land-lobbi">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.project_shablon_fields.lobbi_section_title_img + ')'"></div>
            <h2>{{salesCard.project_shablon_fields.lobbi_title}}</h2>
        </div>
        <div class="desc-html desc-html-mobile" v-html="salesCard.project_shablon_fields.lobbi_desc" v-if="isMobileChecker"></div>
        <div class="container">
            <div class="land-lobbi-column-container">
                <div class="col-right">
                    <div class="lobbi-gallery" :class="{'nav-init' : salesCard.project_shablon_fields.lobbi_gallery != undefined && salesCard.project_shablon_fields.lobbi_gallery.length > 1}">
                        <swiper :options="swiperOption" ref="landLobbiGallery">
                            <swiper-slide v-for="(slide, index) in salesCard.project_shablon_fields.lobbi_gallery" :key="index" @click.native="openModal(index)">
                                <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="swiper-controls sales-land-controls sales-land-lobbi-controls" v-if="salesCard.project_shablon_fields.lobbi_gallery != undefined && salesCard.project_shablon_fields.lobbi_gallery.length > 1">
                        <div class="sales-land-btn-prev sales-land-lobbi-btn-prev slider-btn">
                            <svgIcon name="left-arrow" />
                        </div>
                        <div class="sales-land-btn-next sales-land-lobbi-btn-next slider-btn">
                            <svgIcon name="right-arrow" />
                        </div>
                    </div>
                </div>
                <div class="col-left">
                    <div class="section-title" v-if="!isMobileChecker">
                        <h2>{{salesCard.project_shablon_fields.lobbi_title}}</h2>
                    </div>
                    <div class="desc-html" v-html="salesCard.project_shablon_fields.lobbi_desc"  v-if="!isMobileChecker"></div>
                    <!-- {{ salesCard.project_shablon_fields.lobbi_icon_list.length }} -->
                    <div class="desc-icons-list" :class="{'list-eight' : parseInt(salesCard.project_shablon_fields.lobbi_icon_list.length) > 6 ,'list-six' : parseInt(salesCard.project_shablon_fields.lobbi_icon_list.length, ) <= 6, 'desc-icons-duman' : projectNameG == 'duman'}">
                        <ul>
                            <li v-for="(item, index) in salesCard.project_shablon_fields.lobbi_icon_list" :key="index">
                                <div class="icon-img">
                                    <img :src="item.icon" alt="">
                                </div>
                                <div class="icon-desc">
                                    <p v-html="item.desc"></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="desc-icon-list-inline desc-icon-list-inline-lobbi" v-if="projectNameG == 'duman'">
                <div class="item" v-for="(item, index) in salesCard.project_shablon_fields.lobbi_icon_list" :key="index">
                    <div class="item-img">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="item-info">
                        <p v-html="item.desc"></p>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="modal-gal" v-if="initModalGal && !isMobileChecker">
            <LobbiLand :images="salesCard.project_shablon_fields.lobbi_gallery" :index="indexActivveLobbi" @close="indexActivveLobbi = null" class="lobbi-modal-biggest" @onopen="openGalModal" @onclosed="closeGalModal"></LobbiLand>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import VueGallery from 'vue-gallery';
    export default {
        name: 'sale-land-lobbi',
        components: {
            svgIcon,
            'LobbiLand': VueGallery,
        },
        data () {
            return {
                projectNameG: window.host,
                indexActivveLobbi: null,
                initModalGal: false,
                swiperOption: {
                    effect: 'coverflow',
                    centeredSlides: true,
                    slidesPerView: "auto",
                    initialSlide: 1,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 0,
                        depth: 300,
                        modifier: 1,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: '.sales-land-lobbi-btn-next',
                        prevEl: '.sales-land-lobbi-btn-prev',
                    },
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openModal(index) {
                this.initModalGal = true;
                setTimeout(() => {
                    this.indexActivveLobbi = index
                }, 200);
            },
            openGalModal() {
                document.getElementById('land-lobbi').classList.add('openGallery');
                document.getElementById('header').classList.add('notvisible');
                document.getElementById('footer').classList.add('notvisible');
            },
            closeGalModal() {
                this.initModalGal = false;
                document.getElementById('land-lobbi').classList.remove('openGallery');
                document.getElementById('header').classList.remove('notvisible');
                document.getElementById('footer').classList.remove('notvisible');
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-lobbi.scss';
    @import '@/styles/components/sales/respond/land-lobbi-respond.scss';
</style>